import { ReactNode } from "react";

import { Layout } from "antd";
import { cx } from "class-variance-authority";

import * as theme from "./PageLayout.css";

export interface PageLayoutProps {
    /**
     * Fills the viewport, so `PageContent` scrolls instead of the page.
     */
    fullHeight: boolean;
    children: ReactNode;
}

export function PageLayout({ fullHeight, children }: PageLayoutProps) {
    return (
        <Layout
            className={cx(theme.pageLayout, fullHeight && theme.fullHeight)}
        >
            {children}
        </Layout>
    );
}
